// Cor primária do tenant chega como "H S% L%" (ex: "24 100% 50%") via
// system_settings.primary_color. Parsing aqui pra usar em CSS dinâmico.

const FALLBACK_HSL = { h: 24, s: 100, l: 50 };

export function parsePrimaryHSL(raw) {
  const match = (raw || "").trim().match(/^(\d+)\s+(\d+)%?\s+(\d+)%?$/);
  if (!match) return { ...FALLBACK_HSL };
  return { h: +match[1], s: +match[2], l: +match[3] };
}

// Constrói uma string CSS hsla() clampando o lightness em [5, 95] pra evitar
// branco/preto puro nas extremidades.
export function hslString({ h, s }, lightness, alpha = 1) {
  const l = Math.max(5, Math.min(95, lightness));
  return `hsla(${h}, ${s}%, ${l}%, ${alpha})`;
}
